import { useLayoutEffect, useMemo } from 'react';
import bridge from 'src/utils/bridge';

const merchantInfoMap = {
  zhonganbio: {
    id: 1,
    name: '众安生命商城',
  },
  zadrugstore: {
    id: 2,
    name: '众安好药师大药房',
  },
  zafshealth: {
    id: 3,
    name: '方伞健康商城',
    serviceDocName: '方伞健康用户服务协议',
    privateDocName: '方伞健康个人信息保护政策',
  },
};

interface Options {
  stopSetTitle?: boolean;
}

function useMerchant(params: Options = {}) {
  const { stopSetTitle } = params;
  const currentMerchant = useMemo(() => {
    let merchant = '';
    if (window.location.hostname.includes('zhonganbio')) {
      merchant = 'zhonganbio';
    } else if (window.location.hostname.includes('zadrugstore')) {
      merchant = 'zadrugstore';
    } else if (window.location.hostname.includes('zafshealth')) {
      merchant = 'zafshealth';
    }
    return merchantInfoMap[merchant || 'zhonganbio'];
  }, []);

  useLayoutEffect(() => {
    if (stopSetTitle) {
      return;
    }
    bridge.setTitle(currentMerchant.name);
  }, [currentMerchant, stopSetTitle]);

  return currentMerchant;
}

export default useMerchant;
